// Mirrors CommodityBookDataModel6.Enum.IbcTankEnvironmentalControlEnum ordinal order
export enum IbcTankEnvironmentalControlEnum {
    Unknown,
    Inerting,
    LiquidOrGasPadding,
    Drying,
    NaturalOrForcedVentilation,
    NoSpecialRequirements,
    PaddingAndVentilationorInerting,
    PaddingAndInerting,
    VentilationOrPadding,
}
